import React from "react";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { Users, XIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import type { Order } from "~/providers/order-provider";
import type { Table } from "~/providers/table-provider";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { MemoizedKeypadInput } from "../ui/keypad-input";

export default function OrderGroupSize({
  open,
  onClose,
  order,
  table,
}: {
  open: boolean;
  onClose: (order?: Order) => void;
  order: Order;
  table?: Table;
}) {
  const { t } = useTranslation("common");
  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        if (open === false) {
          onClose();
        }
      }}
    >
      <DialogContent>
        <VisuallyHidden>
          <DialogHeader>
            <DialogTitle></DialogTitle>
            <DialogDescription></DialogDescription>
          </DialogHeader>
        </VisuallyHidden>
        <DialogClose asChild>
          <Button
            className="absolute top-2 right-2 p-1 rounded-full w-8 h-8"
            variant="ghost"
          >
            <XIcon />
          </Button>
        </DialogClose>
        <MemoizedKeypadInput
          icon={<Users className="text-white" />}
          label={t("Order.party_size")}
          description={t("Order.party_size_description")}
          type="number"
          value={table?.maxSeats ?? 2}
          onChange={(value) => {
            onClose({
              id: order.id,
              items: order.items,
              currentRound: order.currentRound,
              tableId: order.tableId,
              updatedAt: order.updatedAt,
              paymentStatus: order.paymentStatus,
              labelIds: order.labelIds,
              ticketPrinted: order.ticketPrinted,
              bookingId: order.bookingId,
              name: order.name,
              partySize: value,
              total: order.total,
              amountPaid: order.amountPaid,
              creditId: order.creditId,
              payments: order.payments,
              createdAt: order.createdAt,
            });
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
